module.exports = __webpack_public_path__ + "img/lock-shut.64c39947.svg";